import { render, staticRenderFns } from "./RoleShow.vue?vue&type=template&id=8d04159c"
import script from "./RoleShow.vue?vue&type=script&lang=ts"
export * from "./RoleShow.vue?vue&type=script&lang=ts"
import style0 from "./RoleShow.vue?vue&type=style&index=0&id=8d04159c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports